// import './App.css';
import { useEffect, useState } from "react";
//import Modal from "react-modal";
import { Modal } from "react-responsive-modal";
import LoadingOverlay from "react-loading-overlay";
import { Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";

import {
  getAssessmentSection,
  getQuestion,
  getAnswer,
  getAssessment,
  deleteQuestion,
  deleteAssessmentSection,
  deleteAnswer,
} from "./../services/api";
import AssessmentsTable from "../components/assessmentsTable";
import AssessmentSectionsTable from "../components/assessmentSectionsTable";
import QuestionsTable from "../components/questionsTable";
import AnswersTable from "../components/answersTable";
import AssessmentSectionForm from "../components/assessmentSectionForm";
import QuestionForm from "../components/questionForm";
import AnswerForm from "../components/answerForm";
import TargetSelector from "../components/targetSelector";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "react-responsive-modal/styles.css";
import { FaTimes } from "react-icons/fa";

function Main() {
  // const organizationId = 1;
  // const assessmentId = 1;

  //SWEET ALERT
  const MySwal = withReactContent(Swal);

  let { organizationId, assessmentId } = useParams();

  const [organization, setOrganization] = useState(null);
  const [assessment, setAssessment] = useState(null);
  const [assessmentSection, setAssessmentSection] = useState(null);
  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState(null);

  const [editAssessmentSection, setEditAssessmentSection] = useState(null);
  const [editQuestion, setEditQuestion] = useState(null);
  const [editAnswer, setEditAnswer] = useState(null);

  const [loading, setLoading] = useState(false);

  const loadAssessment = () => {
    setLoading(true);
    getAssessment(assessmentId).then((res) => {
      setLoading(false);
      setAssessment(res);
    });
  };

  useEffect(() => {
    loadAssessment();
  }, []);

  const onSelectedAssessmentSection = (as, reload) => {
    if (assessmentSection?.id !== as.id || reload) {
      setLoading(true);
      getAssessmentSection(as.id).then((res) => {
        setLoading(false);
        setAssessmentSection(res);
        setQuestion(null);
      });
    }
  };

  const onSelectedQuestion = (q, reload) => {
    if (question?.id !== q.id || reload) {
      setLoading(true);
      getQuestion(q.id).then((res) => {
        setLoading(false);
        if (res.answers) {
          res.answers.sort((a, b) => {
            return a.order - b.order;
          });
        }
        setQuestion(res);
      });
    }
  };

  const onEditAssesmentSection = (as) => {
    setEditAssessmentSection(as);
  };

  const onEditQuestion = (q) => {
    setEditQuestion(q);
  };

  const onEditAnswer = (a) => {
    setEditAnswer(a);
  };

  const swalWithCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: "swal2-confirm btn-main-limber swal2-styled",
    },
  });

  const onDeleteQuestion = (q) => {
    // if (window.confirm(`Are you sure you want to delete question ${q.id}?`)) {
    //   setLoading(true);
    //   deleteQuestion(q.id).then(() => {
    //     setLoading(false);
    //     onSelectedAssessmentSection(assessmentSection, true);
    //   });
    // }
    setLoading(true);
    Swal.fire({
      title: `Are you sure you want to delete question ${q.id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      customClass: {
        confirmButton: "btn-main-limber",
        cancelButton: "btn-green-limber",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        deleteQuestion(q.id).then(() => {
          onSelectedAssessmentSection(assessmentSection, true);
          swalWithCustomButtons.fire("Deleted!", "Your question has been deleted.", "success", {
            customClass: {
              confirmButton: "btn-main-limber",
            },
          });
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    });
  };

  const onDeleteAssessmentSection = (as) => {
    // if (window.confirm(`Are you sure you want to delete section ${as.id}?`)) {
    //   setLoading(true);
    //   deleteAssessmentSection(as.id).then(() => {
    //     setLoading(false);
    //     loadAssessment();
    //   });
    // }

    setLoading(true);
    Swal.fire({
      title: `Are you sure you want to delete section ${as.id}?`,
      icon: "warning",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn-main-limber",
        cancelButton: "btn-green-limber",
      },
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAssessmentSection(as.id).then(() => {
          loadAssessment();
          swalWithCustomButtons.fire("Deleted!", "Your section has been deleted.", "success", {
            customClass: {
              confirmButton: "btn-main-limber",
            },
          });
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    });
  };

  const onDeleteAnswer = (a) => {
    // if (window.confirm(`Are you sure you want to delete answer ${a.id}?`)) {
    //   setLoading(true);
    //   deleteAnswer(a.id).then(() => {
    //     setLoading(false);
    //     onSelectedQuestion(question, true);
    //   });
    // }

    setLoading(true);
    Swal.fire({
      title: `Are you sure you want to delete answer ${a.id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      customClass: {
        confirmButton: "btn-main-limber",
        cancelButton: "btn-green-limber",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAnswer(a.id).then(() => {
          onSelectedQuestion(question, true);
          swalWithCustomButtons.fire("Deleted!", "Your answer has been deleted.", "success", {
            customClass: {
              confirmButton: "btn-main-limber",
            },
          });
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    });
  };

  const closeModal = () => {
    setEditAssessmentSection(null);
    setEditQuestion(null);
    setEditAnswer(null);
  };

  const onSaveSuccessQuestion = () => {
    onSelectedAssessmentSection(assessmentSection, true);
  };

  const onSaveSuccessAssessmentSection = () => {
    loadAssessment();
  };

  const onSaveSuccessAnswer = () => {
    onSelectedQuestion(question, true);
  };

  const styleModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    zIndex: 1000,
  };

  return (
    <LoadingOverlay active={loading} spinner style={{ height: "100%" }}>
      <Grid container>
        {/* {organization && <AssessmentsTable assessments={organization.assessments} onElementSelected={ } />} */}

        {assessment && (
          <Grid item xs={12} md={4}>
            <AssessmentSectionsTable
              organizationId={organizationId}
              assessmentSections={assessment.assessmentSections}
              selectedElementId={assessmentSection?.id}
              onElementSelected={onSelectedAssessmentSection}
              onEdit={onEditAssesmentSection}
              onDelete={onDeleteAssessmentSection}
            />
          </Grid>
        )}

        {assessmentSection && (
          <Grid item xs={12} md={4}>
            <QuestionsTable
              questions={assessmentSection.questions}
              selectedElementId={question?.id}
              onElementSelected={onSelectedQuestion}
              onEdit={onEditQuestion}
              onDelete={onDeleteQuestion}
            />
          </Grid>
        )}

        {question && (
          <Grid item xs={12} md={4}>
            <AnswersTable answers={question.answers} onEdit={onEditAnswer} onDelete={onDeleteAnswer} />
          </Grid>
        )}

        <Modal
          open={editAssessmentSection || editQuestion || editAnswer}
          onClose={closeModal}
          contentLabel="Example Modal"
          classNames={{
            modal: "modalEdit",
          }}
          center
        >
          {/* <div className="closeModal">
            <FaTimes className="icon-limber" size="1.5em" onClick={() => closeModal()} />
          </div> */}

          {editAssessmentSection && (
            <AssessmentSectionForm
              assessmentSection={editAssessmentSection}
              assessmentId={assessmentId}
              onSaveSuccess={onSaveSuccessAssessmentSection}
            />
          )}
          {editQuestion && (
            <QuestionForm
              question={editQuestion}
              assessmentSectionId={assessmentSection.id}
              onSaveSuccess={onSaveSuccessQuestion}
              assessmentSections={assessment.assessmentSections}
              selectedAssessmentSection={assessmentSection}
            />
          )}
          {editAnswer && (
            <AnswerForm
              answer={editAnswer}
              questionId={question.id}
              onSaveSuccess={onSaveSuccessAnswer}
              assessmentSections={assessment.assessmentSections}
              selectedAssessmentSection={assessmentSection}
            />
          )}
        </Modal>
      </Grid>
    </LoadingOverlay>
  );
}

export default Main;
